import { AxiosResponse } from "axios";
import fileDownload from "js-file-download";
import { axiosClient } from "../lib/axios-client";

const toJson = (response: AxiosResponse<any>) => {
	if (response.status === 204) return undefined;
	return response.data.data ?? response.data;
};

export const getJson = async <T>(url: string, data?: any): Promise<T> => {
	const config = { params: data };
	return axiosClient.get(url, config).then(toJson);
};

export const postJson = <T>(url: string, data?: any): Promise<T> =>
	axiosClient.post(url, data).then(toJson);

export const putJson = (url: string, data?: any) =>
	axiosClient.put(url, data).then(toJson);

export const deleteJson = (url: string, data?: any) =>
	axiosClient.delete(url, {
		data: data
	}).then(toJson);

export type AcceptContentType = "text/plain" | "application/octet-stream" | "application/pdf";

export const downloadFile = (url: string, filename: string, data?: any, acceptContentType?: AcceptContentType) => {
	return axiosClient.get(url, {
		params: data,
		headers: {
			Accept: acceptContentType
		},
		responseType: "blob"
	}).then(res => {
		fileDownload(res.data, filename);
	});
};